import { Phone, PhoneOff } from 'lucide-react'

/**
 * Story 3.16.1 — Display read-only para listas de telefones em formato
 * E.164 (ghl_test_phone_allowlist e similares).
 *
 * Caso especial: array vazio → label semântica "sem restrição" (allowlist
 * vazia significa todos os telefones passam — comportamento documentado
 * no setting `ghl_test_phone_allowlist`).
 */
export function PhoneListDisplay({
  value,
  emptyLabel = '(vazio — sem restrição)',
}: {
  value: unknown
  emptyLabel?: string
}): React.ReactElement {
  if (!Array.isArray(value)) {
    return <code className="text-xs text-muted-foreground">(formato inválido)</code>
  }
  const phones = value.filter((p): p is string => typeof p === 'string')

  if (phones.length === 0) {
    return (
      <div className="flex items-center gap-2 text-sm text-muted-foreground">
        <PhoneOff className="h-3.5 w-3.5" aria-hidden="true" />
        <span>{emptyLabel}</span>
      </div>
    )
  }

  return (
    <div className="space-y-1 text-sm">
      <div className="flex items-center gap-2">
        <Phone className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
        <span>
          <span className="font-medium">{phones.length}</span>{' '}
          <span className="text-muted-foreground">
            telefone{phones.length === 1 ? '' : 's'}
          </span>
        </span>
      </div>
      <ul className="ml-5 list-disc text-xs text-muted-foreground">
        {phones.slice(0, 5).map((p, i) => (
          <li key={`${p}-${i}`} className="font-mono">
            {p}
          </li>
        ))}
        {phones.length > 5 && (
          <li className="italic">… +{phones.length - 5} a mais</li>
        )}
      </ul>
    </div>
  )
}
